/**
 * Ar App
 * This is a simple API for AR App
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csong@lsq.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ArError } from '../model/arError';
import { ProspectData } from '../model/prospectData';
import { ProspectLight } from '../model/prospectLight';
import { StageData } from '../model/stageData';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ProspectService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create a new ProspectData
     * Create a new ProspectData to the system. Admin only.
     * @param body Prospect JSON object to add
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addProspectData(body?: ProspectData, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public addProspectData(body?: ProspectData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public addProspectData(body?: ProspectData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public addProspectData(body?: ProspectData, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProspectData>('post',`${this.basePath}/v1/prospectData`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deletes ProspectData
     * Delete an existing ProspectData by ProspectID. Admin only.
     * @param prospectId pass an optional Id for looking up ProspectData
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteProspectData(prospectId: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public deleteProspectData(prospectId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public deleteProspectData(prospectId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public deleteProspectData(prospectId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling deleteProspectData.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProspectData>('delete',`${this.basePath}/v1/prospectData`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Searches deleted prospect data
     * By passing in the appropriate options, you can search for prospects that were previously deleted. Admin only.
     * @param prospectId pass an optional ProspectID for looking up prospect data
     * @param businessName pass an optional businessName for looking up prospect data
     * @param status pass an optional status for looking up prospect data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDeletedProspectData(prospectId?: string, businessName?: string, status?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProspectData>>;
    public getDeletedProspectData(prospectId?: string, businessName?: string, status?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProspectData>>>;
    public getDeletedProspectData(prospectId?: string, businessName?: string, status?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProspectData>>>;
    public getDeletedProspectData(prospectId?: string, businessName?: string, status?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }
        if (businessName !== undefined && businessName !== null) {
            queryParameters = queryParameters.set('businessName', <any>businessName);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ProspectData>>('get',`${this.basePath}/v1/deletedProspectData`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Searches prospect data
     * By passing in the appropriate options, you can search for available prospects in the system. Admin only.
     * @param prospectId pass an optional ProspectID for looking up prospect data
     * @param businessName pass an optional businessName for looking up prospect data
     * @param status pass an optional status for looking up prospect data
     * @param schemaTypes pass an array of schemaType to only pull back prospectData of those schemaTypes
     * @param includeDeleted Whether to include deleted prospect data. default to false. Only used by Admins.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProspectData(prospectId?: string, businessName?: string, status?: string, schemaTypes?: Array<string>, includeDeleted?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<ProspectData>>;
    public getProspectData(prospectId?: string, businessName?: string, status?: string, schemaTypes?: Array<string>, includeDeleted?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProspectData>>>;
    public getProspectData(prospectId?: string, businessName?: string, status?: string, schemaTypes?: Array<string>, includeDeleted?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProspectData>>>;
    public getProspectData(prospectId?: string, businessName?: string, status?: string, schemaTypes?: Array<string>, includeDeleted?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }
        if (businessName !== undefined && businessName !== null) {
            queryParameters = queryParameters.set('businessName', <any>businessName);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (schemaTypes) {
            queryParameters = queryParameters.set('schemaTypes', schemaTypes.join(COLLECTION_FORMATS['csv']));
        }
        if (includeDeleted !== undefined && includeDeleted !== null) {
            queryParameters = queryParameters.set('includeDeleted', <any>includeDeleted);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ProspectData>>('get',`${this.basePath}/v1/prospectData`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Find data by companyKey and schemaType or create it with businessName
     * Find data by companyKey and schemaType. Make data and schema if it does not exist.
     * @param companyKey pass a companyKey for looking up data
     * @param schemaType pass a schemaType for looking up data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProspectDataByCompanykeyAndSchematype(companyKey: string, schemaType: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public getProspectDataByCompanykeyAndSchematype(companyKey: string, schemaType: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public getProspectDataByCompanykeyAndSchematype(companyKey: string, schemaType: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public getProspectDataByCompanykeyAndSchematype(companyKey: string, schemaType: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (companyKey === null || companyKey === undefined) {
            throw new Error('Required parameter companyKey was null or undefined when calling getProspectDataByCompanykeyAndSchematype.');
        }

        if (schemaType === null || schemaType === undefined) {
            throw new Error('Required parameter schemaType was null or undefined when calling getProspectDataByCompanykeyAndSchematype.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (companyKey !== undefined && companyKey !== null) {
            queryParameters = queryParameters.set('company_key', <any>companyKey);
        }
        if (schemaType !== undefined && schemaType !== null) {
            queryParameters = queryParameters.set('schema_type', <any>schemaType);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProspectData>('get',`${this.basePath}/v1/prospectData/ByCompanyKeyAndSchemaType`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searches prospect detail with all properties by ProspectID
     * Get full prospect details by ProspectID.
     * @param prospectId pass the ProspectID for looking up prospect details
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProspectDataById(prospectId: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public getProspectDataById(prospectId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public getProspectDataById(prospectId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public getProspectDataById(prospectId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling getProspectDataById.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProspectData>('get',`${this.basePath}/v1/prospectData/ById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Find a prospect by token
     * Find a prospect by token from invitation. No authentication needed.
     * @param token pass a token for looking up prospect
     * @param prospectId pass an id for looking up prospect
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProspectDataByToken(token: string, prospectId: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public getProspectDataByToken(token: string, prospectId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public getProspectDataByToken(token: string, prospectId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public getProspectDataByToken(token: string, prospectId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling getProspectDataByToken.');
        }

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling getProspectDataByToken.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProspectData>('get',`${this.basePath}/v1/prospectData/ByToken`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Searches prospect data (light version)
     * By passing in the appropriate options, you can search for available prospects in the system. Admin only.
     * @param prospectId pass an optional ProspectID for looking up prospect data
     * @param businessName pass an optional businessName for looking up prospect data
     * @param status pass an optional status for looking up prospect data
     * @param schemaTypes pass an array of schemaType to only pull back prospectData of those schemaTypes
     * @param includeDeleted Whether to include deleted prospect data. default to false. Only used by Admins.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getProspectDataLight(prospectId?: string, businessName?: string, status?: string, schemaTypes?: Array<string>, includeDeleted?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<ProspectLight>>;
    public getProspectDataLight(prospectId?: string, businessName?: string, status?: string, schemaTypes?: Array<string>, includeDeleted?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProspectLight>>>;
    public getProspectDataLight(prospectId?: string, businessName?: string, status?: string, schemaTypes?: Array<string>, includeDeleted?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProspectLight>>>;
    public getProspectDataLight(prospectId?: string, businessName?: string, status?: string, schemaTypes?: Array<string>, includeDeleted?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }
        if (businessName !== undefined && businessName !== null) {
            queryParameters = queryParameters.set('businessName', <any>businessName);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (schemaTypes) {
            queryParameters = queryParameters.set('schemaTypes', schemaTypes.join(COLLECTION_FORMATS['csv']));
        }
        if (includeDeleted !== undefined && includeDeleted !== null) {
            queryParameters = queryParameters.set('includeDeleted', <any>includeDeleted);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ProspectLight>>('get',`${this.basePath}/v1/prospectDataLight`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * update prospect status
     * Update prospect status
     * @param prospectId pass the ProspectID to update
     * @param businessName pass the name of the company
     * @param status pass an optional status for looking up prospect data
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putProspectDataStatus(prospectId: string, businessName: string, status: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public putProspectDataStatus(prospectId: string, businessName: string, status: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public putProspectDataStatus(prospectId: string, businessName: string, status: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public putProspectDataStatus(prospectId: string, businessName: string, status: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling putProspectDataStatus.');
        }

        if (businessName === null || businessName === undefined) {
            throw new Error('Required parameter businessName was null or undefined when calling putProspectDataStatus.');
        }

        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling putProspectDataStatus.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }
        if (businessName !== undefined && businessName !== null) {
            queryParameters = queryParameters.set('business_name', <any>businessName);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProspectData>('get',`${this.basePath}/v1/prospectData/status`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update StageData in an existing ProspectData
     * Update StageData in an existing ProspectData
     * @param body StageData object to update
     * @param prospectId pass the ProspectID to update
     * @param stageSchemaId pass the StageSchemaID to update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateStageData(body: StageData, prospectId: string, stageSchemaId: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public updateStageData(body: StageData, prospectId: string, stageSchemaId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public updateStageData(body: StageData, prospectId: string, stageSchemaId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public updateStageData(body: StageData, prospectId: string, stageSchemaId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateStageData.');
        }

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling updateStageData.');
        }

        if (stageSchemaId === null || stageSchemaId === undefined) {
            throw new Error('Required parameter stageSchemaId was null or undefined when calling updateStageData.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }
        if (stageSchemaId !== undefined && stageSchemaId !== null) {
            queryParameters = queryParameters.set('stage_schema_id', <any>stageSchemaId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProspectData>('put',`${this.basePath}/v1/prospectData/stageData`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update watchers in an existing ProspectData
     * Update watchers in an existing ProspectData
     * @param body New full list of watchers on the prospect
     * @param prospectId pass the ProspectID to update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateWatchers(body: Array<string>, prospectId: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public updateWatchers(body: Array<string>, prospectId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public updateWatchers(body: Array<string>, prospectId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public updateWatchers(body: Array<string>, prospectId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateWatchers.');
        }

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling updateWatchers.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProspectData>('put',`${this.basePath}/v1/prospectData/watchers`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
